import { isArray } from 'lodash';

export const SET_FORM_DATA = 'SET_FORM_DATA';
export const setFormData = (form, data) => ({
    type: SET_FORM_DATA,
    form,
    data,
});

export const SET_FORM_BY_ID = 'SET_FORM_BY_ID';
export const setFormById = (form, id, value) => ({
    type: SET_FORM_BY_ID,
    form,
    id,
    value,
});

export const CHANGE_FORM_BY_INDEX = 'CHANGE_FORM_BY_INDEX';
export const changeFormByIndex = (form, index, value) => ({
    type: CHANGE_FORM_BY_INDEX,
    form,
    index,
    value,
});
export const DELETE_ITEM_FORM = 'DELETE_ITEM_FORM';
export const deleteItemForm = (form, index) => ({
    type: DELETE_ITEM_FORM,
    form,
    index,
});

export const ADD_ITEM_FORM = 'ADD_ITEM_FORM';
export const addForm = (form, value) => ({
    type: ADD_ITEM_FORM,
    form,
    value,
});

export const SET_SELL_FORM_FIELD_VALUE = 'SET_SELL_FORM_FIELD_VALUE';
export const setFieldValue = (form, field, value) => ({
    type: SET_SELL_FORM_FIELD_VALUE,
    form,
    field,
    value,
});

export const SET_SELL_FORM_FIELD_ERROR_MESSAGE = 'SET_SELL_FORM_FIELD_ERROR_MESSAGE';
export const setFieldErrorMessage = (form, field, errorMessage) => ({
    type: SET_SELL_FORM_FIELD_ERROR_MESSAGE,
    form,
    field,
    errorMessage,
});
export const SET_SELL_FORM_FIELD_VISIBILITY = 'SET_SELL_FORM_FIELD_VISIBILITY';
export const setFieldVisibility = (form, field, isVisible) => ({
    type: SET_SELL_FORM_FIELD_VISIBILITY,
    form,
    field,
    isVisible,
});

export const SET_HAS_MULTIPLE_EVENTS = 'SET_HAS_MULTIPLE_EVENTS';
export const setHasMultipleEvents = (hasMultipleEvents) => ({
    type: SET_HAS_MULTIPLE_EVENTS,
    hasMultipleEvents,
});

export const handleRequestErrors = (form, formattedResponse, dispatch) => {
    const { errors } = formattedResponse;
    errors.forEach(({
        field,
        message,
    }) => {
        if (isArray(field)) {
            field.forEach((name) => {
                dispatch(setFieldErrorMessage(form, name, message));
            });
        } else {
            dispatch(setFieldErrorMessage(form, field, message));
        }
    });
};
